/* eslint-disable */
import React, { useState } from "react";
import PropTypes from "prop-types";
import FeatherIcon from "feather-icons-react";
import alertify from "alertifyjs";
import { UpdateUserServer, UploadProfileImg } from "../../services/apiUtils";

const AdminDetailEdit = ({ editUser, setEditModal, setEditUser }) => {
  const [errors, setErrors] = useState({});

  const validate = (name, value) => {
    const newErrors = { ...errors };
    const phonePattern = /^[0-9]{10}$/;
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

    switch (name) {
      case "Name":
        newErrors.Name = value ? "" : "Name is required";
        break;
      case "City":
        newErrors.City = value ? "" : "City is required";
        break;
      case "State":
        newErrors.State = value ? "" : "State is required";
        break;
      case "Country":
        newErrors.Country = value ? "" : "Country is required";
        break;
      case "GeoLocation":
        newErrors.GeoLocation = value ? "" : "GeoLocation is required";
        break;
      case "Email":
        newErrors.Email = emailPattern.test(value)
          ? ""
          : "Invalid email format";
        break;
      case "Phone":
        newErrors.Phone = phonePattern.test(value)
          ? ""
          : "Phone number must be 10 digits";
        break;
      default:
        break;
    }

    setErrors(newErrors);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditUser((prev) => ({
      ...prev,
      [name]: value,
    }));
    validate(name, value);
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    validate(name, value);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const validTypes = ["image/png", "image/jpeg", "image/jpg"];
      if (!validTypes.includes(file.type)) {
        alert("Invalid file type. Only PNG, JPG, and JPEG are allowed.");
        return;
      }

      const formData = new FormData();
      const timestamp = new Date()
        .toISOString()
        .replace(/[-:]/g, "")
        .replace("T", "_")
        .split(".")[0];
      const fileName = `UserProfile_${timestamp}.jpeg`;
      formData.append("file", new Blob([file], { type: file.type }), fileName);

      uploadProfileImage(formData);
    }
  };

  const uploadProfileImage = async (formData) => {
    try {
      console.log("formData", formData);
      console.log("editUser.ID", editUser.ID);
      const response = await UploadProfileImg(formData, editUser.ID);
      if (response?.data?.path) {
        toastrSuccess("Profile image updated!");
        setEditUser((prev) => ({ ...prev, Profile: response.data.path }));
      } else {
        toastrError("Failed to upload image.");
      }
    } catch (error) {
      toastrError("Image upload error.");
    }
  };

  const getGpsLocation = async (e) => {
    e.preventDefault();
    if (!navigator.geolocation) {
      toastrError("Geolocation not supported.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        const geoLoc = `${latitude},${longitude}`;
        setEditUser((prev) => ({
          ...prev,
          GeoLocation: geoLoc,
        }));
        toastrSuccess("Location retrieved successfully.");
      },
      (error) => {
        let errorMessage = "Location fetch failed.";
        if (error.code === error.PERMISSION_DENIED)
          errorMessage = "Permission denied for location.";
        if (error.code === error.POSITION_UNAVAILABLE)
          errorMessage = "Location unavailable.";
        if (error.code === error.TIMEOUT)
          errorMessage = "Location fetch timed out.";
        toastrError(errorMessage);
      }
    );
  };

  const toastrSuccess = (message) => {
    alertify.dismissAll();
    alertify.set("notifier", "position", "top-right");
    alertify.success(message);
  };

  const toastrError = (message) => {
    alertify.dismissAll();
    alertify.set("notifier", "position", "top-right");
    alertify.error(message);
  };

  const handleSubmit = async () => {
    const hasErrors = Object.values(errors).some((error) => error);
    if (hasErrors) {
      toastrError("Please fix form errors.");
      return;
    }

    const trimmedData = {
      Name: editUser.Name,
      Email: editUser.Email,
      Phone: editUser.Phone,
      Address: editUser.Address,
      City: editUser.City,
      State: editUser.State,
      GeoLocation: "",
      Status: editUser.Status,
      Id: editUser.ID,
      Profile: editUser.Profile,
    };

    console.log("trimmedData", trimmedData);

    const Response = await UpdateUserServer(trimmedData);

    console.log("Response", Response);
    if (Response.success === 200) {
      localStorage.setItem("user", JSON.stringify(editUser));
      toastrSuccess("User updated.");
      setEditModal(true);
    } else {
      toastrError("Failed to update user.");
    }
  };

  return (
    <div className="page-wrapper">
      <div className="card">
        <div className="head d-flex justify-content-start align-items-center ms-3 mt-5">
          <button
            type="button"
            className="btn btn-link"
            onClick={() => setEditModal(true)}
          >
            Back
          </button>
          <h5 className="modal-title">Edit Profile</h5>
        </div>
        <div className="card-body">
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="mb-3">
              <label
                className="avatar avatar-xxl profile-cover-avatar mt-2"
                htmlFor="avatar_upload"
              >
                <img
                  className="avatar-img"
                  src={`https://api.cenpilot.in${editUser.Profile}`}
                  alt="Profile"
                />
                <input
                  type="file"
                  id="avatar_upload"
                  accept="image/png, image/jpeg, image/jpg"
                  onChange={handleFileChange}
                />
                <span className="avatar-edit">
                  <FeatherIcon
                    icon="edit"
                    className="avatar-uploader-icon shadow-soft"
                  />
                </span>
              </label>
            </div>

            {[
              { label: "Name", type: "text" },
              { label: "Email", type: "text" },
              { label: "Phone", type: "text" },
              { label: "City", type: "text" },
              { label: "State", type: "text" },
              { label: "Country", type: "text", field: "Address" },
            ].map(({ label, type, field }) => {
              const name = field || label;
              return (
                <div className="mb-3" key={name}>
                  <label htmlFor={name} className="form-label">
                    {label}
                  </label>
                  <input
                    type={type}
                    className={`form-control ${
                      errors[name] ? "is-invalid" : ""
                    }`}
                    id={name}
                    name={name}
                    value={editUser[name]}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required
                  />
                  {errors[name] && (
                    <div className="invalid-feedback">{errors[name]}</div>
                  )}
                </div>
              );
            })}

            {/* <div className="mb-3">
              <label htmlFor="GeoLocation" className="form-label">
                Location
              </label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  readOnly
                  value={editUser.GeoLocation || "Click 'Get Location'"}
                />
                <button onClick={getGpsLocation} className="btn btn-primary">
                  <i className="bi bi-geo-alt-fill"></i> Get Location
                </button>
              </div>
            </div> */}
          </form>
        </div>

        <div className="modal-footer d-flex gap-2">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setEditModal(false)}
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSubmit}
          >
            Save changes
          </button>
        </div>
      </div>
    </div>
  );
};

AdminDetailEdit.propTypes = {
  editUser: PropTypes.shape({
    Name: PropTypes.string.isRequired,
    Email: PropTypes.string.isRequired,
    Phone: PropTypes.string.isRequired,
    Address: PropTypes.string.isRequired,
    City: PropTypes.string.isRequired,
    State: PropTypes.string.isRequired,
    GeoLocation: PropTypes.string,
    Status: PropTypes.number.isRequired,
    ID: PropTypes.number.isRequired,
    Profile: PropTypes.string.isRequired,
  }).isRequired,
  setEditModal: PropTypes.func.isRequired,
  setEditUser: PropTypes.func.isRequired,
};

export default AdminDetailEdit;
